import InputGroup from '@shared/components/InputGroup/InputGroup';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Layout } from 'assets/icons/Layout.svg';

import { NewChatFormType } from './CreateNewChatModal';

const ChatNameField = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<NewChatFormType>();
  const { t } = useTranslation();

  return (
    <div className="flex w-full gap-5 items-center">
      <Layout className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5" />
      <InputGroup variant="white-bg" errorMessage={errors.chatName?.message}>
        <Controller
          name="chatName"
          control={control}
          render={({ field: { onChange, value } }) => (
            <InputGroup.Input
              onChange={onChange}
              value={value}
              placeholder={t('messenger.chat_name_placeholder')}
              className="!bg-gray-10"
              required={false}
            />
          )}
        />
      </InputGroup>
    </div>
  );
};

export default ChatNameField;
